import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import {
    PdpSharedDescriptionAdditionalOptionsContent,
    Title,
} from './PdpSharedDescriptionAdditionalOptionsContent';

// styles
import styles from './PdpSharedDescription.scss';

// helpers
import get from 'lodash.get';
import classNames from 'classnames';

function PdpSharedDescriptionAdditionalOptionsComponent(props) {
    const { headerClass, contentClass, wrapperClass, item, user, buttonType } = props;
    const { isCustomizable } = item;
    const customizationOptions = get(item, 'attributes.customizable[0].text');

    if (!isCustomizable || !customizationOptions) {
        return null;
    }

    return (
        <div
            data-tn="pdp-item-description-customization-options"
            className={classNames(styles.wrapper, wrapperClass)}
        >
            <h2 className={classNames(styles.header, headerClass)}>
                <Title />
            </h2>
            <PdpSharedDescriptionAdditionalOptionsContent
                customizationOptions={customizationOptions}
                contentClass={contentClass}
                buttonType={buttonType}
                item={item}
                user={user}
            />
        </div>
    );
}

PdpSharedDescriptionAdditionalOptionsComponent.propTypes = {
    wrapperClass: PropTypes.string,
    contentClass: PropTypes.string,
    headerClass: PropTypes.string,
    buttonType: PropTypes.string,
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
};

export const PdpSharedDescriptionAdditionalOptions = createFragmentContainer(
    PdpSharedDescriptionAdditionalOptionsComponent,
    {
        user: graphql`
            fragment PdpSharedDescriptionAdditionalOptions_user on User {
                ...PdpSharedDescriptionAdditionalOptionsContent_user
            }
        `,
        item: graphql`
            fragment PdpSharedDescriptionAdditionalOptions_item on Item {
                ...PdpSharedDescriptionAdditionalOptionsContent_item
                isCustomizable
                attributes {
                    customizable {
                        text
                    }
                }
            }
        `,
    }
);
